/* HFD SELL 2026 — one small script. No dependencies. */
(function () {
  'use strict';
  var d = document, w = window;
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function on(el, ev, fn, o) { el && el.addEventListener(ev, fn, o || false); }

  /* ---------- money (uses the shop format set in Liquid) ---------- */
  var moneyFormat = (w.SELL && w.SELL.moneyFormat) || '€{{amount_with_comma_separator}}';
  function money(cents) {
    var v = (cents / 100);
    var out = moneyFormat;
    function fmt(dec, thou, decimals) {
      var s = v.toFixed(decimals);
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return decimals ? parts.join(dec) : parts[0];
    }
    out = out.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, fmt(',', '.', 0))
             .replace(/\{\{\s*amount_no_decimals\s*\}\}/, fmt('.', ',', 0))
             .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, fmt(',', '.', 2))
             .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/, fmt('.', "'", 2))
             .replace(/\{\{\s*amount\s*\}\}/, fmt('.', ',', 2));
    return out;
  }

  /* ---------- header drawer ---------- */
  $$('[data-s-drawer-open]').forEach(function (btn) {
    var dr = $('#' + btn.getAttribute('aria-controls'));
    if (!dr) return;
    var lastFocus;
    function open() {
      lastFocus = d.activeElement; dr.setAttribute('open', ''); btn.setAttribute('aria-expanded', 'true');
      d.documentElement.style.overflow = 'hidden';
      var f = $('button[data-s-drawer-close]', dr); f && f.focus();
    }
    function close() {
      dr.removeAttribute('open'); btn.setAttribute('aria-expanded', 'false');
      d.documentElement.style.overflow = ''; lastFocus && lastFocus.focus();
    }
    on(btn, 'click', open);
    $$('[data-s-drawer-close]', dr).forEach(function (c) { on(c, 'click', close); });
    on(d, 'keydown', function (e) { if (e.key === 'Escape' && dr.hasAttribute('open')) close(); });
  });

  /* ---------- outbound buy clicks → pixel / GA / dataLayer ---------- */
  on(d, 'click', function (e) {
    var a = e.target.closest && e.target.closest('[data-s-out]');
    if (!a) return;
    var dest = a.getAttribute('data-s-out'), where = a.getAttribute('data-s-where') || '';
    try {
      if (w.fbq) w.fbq('trackCustom', 'OutboundBuyClick', { destination: dest, placement: where });
      if (w.gtag) w.gtag('event', 'outbound_buy_click', { destination: dest, placement: where });
      (w.dataLayer = w.dataLayer || []).push({ event: 'outbound_buy_click', destination: dest, placement: where });
    } catch (err) {}
  }, true);

  /* ---------- product: variant picker + gallery + sticky bar ---------- */
  $$('[data-s-product]').forEach(function (root) {
    var data; try { data = JSON.parse($('[data-s-variants]', root).textContent); } catch (e) { return; }
    var variants = data.variants || [], media = data.media || [];
    var form = $('form[data-s-form]', root);
    var idInput = $('input[name="id"]', form);
    var priceNow = $('[data-s-price]', root), priceWas = $('[data-s-was]', root), save = $('[data-s-save]', root);
    var mainImg = $('[data-s-main]', root), mainWrap = mainImg && mainImg.parentElement;
    var thumbs = $$('[data-s-thumb]', root);
    var buyBtn = $('[data-s-buy]', form);
    var legend = $('[data-s-legend]', root);
    var sticky = $('[data-s-sticky]');
    var stickyPrice = sticky && $('[data-s-sticky-price]', sticky);

    function showMedia(id) {
      var m = null; for (var i = 0; i < media.length; i++) if (String(media[i].id) === String(id)) m = media[i];
      if (!m || !mainImg) return;
      if (mainImg.getAttribute('data-id') === String(m.id)) return;
      mainWrap.classList.add('is-swapping');
      var img = new Image();
      img.onload = function () {
        mainImg.src = m.src; mainImg.srcset = m.srcset || ''; mainImg.alt = m.alt || mainImg.alt;
        mainImg.setAttribute('data-id', m.id); mainWrap.classList.remove('is-swapping');
      };
      img.src = m.src;
      thumbs.forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-s-thumb') === String(m.id) ? 'true' : 'false'); });
    }
    thumbs.forEach(function (t) { on(t, 'click', function () { showMedia(t.getAttribute('data-s-thumb')); }); });

    function applyVariant(v, push) {
      if (!v) return;
      idInput.value = v.id;
      if (priceNow) priceNow.textContent = money(v.price);
      if (priceWas) {
        if (v.compare_at_price && v.compare_at_price > v.price) { priceWas.textContent = money(v.compare_at_price); priceWas.hidden = false; }
        else priceWas.hidden = true;
      }
      if (save) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          save.textContent = (save.getAttribute('data-label') || 'Save') + ' ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; save.hidden = false;
        } else save.hidden = true;
      }
      if (stickyPrice) stickyPrice.innerHTML = money(v.price) + (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '');
      if (legend) { var li = $('input[data-s-option][value="' + String(v.option1).replace(/"/g, '\\"') + '"]', root); var ll = li && $('label[for="' + li.id + '"]', root); if (ll) legend.textContent = ll.textContent.trim(); }
      if (buyBtn) {
        buyBtn.disabled = !v.available;
        var lbl = $('[data-s-buy-label]', buyBtn);
        if (lbl) lbl.textContent = v.available ? (buyBtn.getAttribute('data-label') || 'Buy now') : (buyBtn.getAttribute('data-soldout') || 'Sold out');
        var bp = $('[data-s-buy-price]', buyBtn); if (bp) bp.textContent = v.available ? money(v.price) : '';
      }
      form.classList.toggle('is-soldout', !v.available);
      if (v.featured_media_id) showMedia(v.featured_media_id);
      if (push && w.history && w.history.replaceState) {
        var u = new URL(w.location.href); u.searchParams.set('variant', v.id); w.history.replaceState({}, '', u);
      }
    }
    $$('input[data-s-option]', root).forEach(function (inp) {
      on(inp, 'change', function () {
        var val = inp.value, v = null;
        for (var i = 0; i < variants.length; i++) if (variants[i].option1 === val) v = variants[i];
        applyVariant(v, true);
      });
    });
    // initial
    var cur = null; for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(idInput.value)) cur = variants[i];
    applyVariant(cur || variants[0], false);

    // sticky bar
    if (sticky && buyBtn && 'IntersectionObserver' in w) {
      var io = new IntersectionObserver(function (en) {
        var r = en[0];
        var onNow = !r.isIntersecting && r.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', onNow);
        sticky.setAttribute('aria-hidden', onNow ? 'false' : 'true');
        var sbb = $('[data-s-sticky-btn]', sticky); if (sbb) sbb.tabIndex = onNow ? 0 : -1;
      }, { threshold: 0 });
      io.observe(buyBtn);
      var sb = $('[data-s-sticky-btn]', sticky);
      on(sb, 'click', function (e) { e.preventDefault(); if (form.requestSubmit) form.requestSubmit(); else form.submit(); });
    }
  });

  /* ---------- UGC clips: tap to play, one at a time, lazy ---------- */
  var playing = null;
  $$('[data-s-clip]').forEach(function (clip) {
    var v = $('video', clip), btn = $('[data-s-clip-play]', clip), mute = $('[data-s-clip-mute]', clip);
    if (!v) return;
    function stop() { v.pause(); clip.classList.remove('is-playing'); btn && btn.setAttribute('aria-pressed', 'false'); if (playing === v) playing = null; }
    function play() {
      if (playing && playing !== v) { var p = playing.closest('[data-s-clip]'); playing.pause(); p && p.classList.remove('is-playing'); }
      if (!v.getAttribute('src') && v.getAttribute('data-src')) v.setAttribute('src', v.getAttribute('data-src'));
      v.muted = false;
      var pr = v.play();
      if (pr && pr.catch) pr.catch(function () { v.muted = true; v.play(); });
      clip.classList.add('is-playing'); playing = v; btn && btn.setAttribute('aria-pressed', 'true');
    }
    on(btn, 'click', function () { clip.classList.contains('is-playing') ? stop() : play(); });
    on(mute, 'click', function (e) { e.stopPropagation(); v.muted = !v.muted; mute.setAttribute('aria-pressed', v.muted ? 'true' : 'false'); });
    on(v, 'ended', stop);
    if ('IntersectionObserver' in w) {
      var io = new IntersectionObserver(function (en) { if (!en[0].isIntersecting && playing === v) stop(); }, { threshold: .2 });
      io.observe(clip);
    }
  });

  /* ---------- sticky header: let the announcement bar scroll away ---------- */
  var ann = $('.s-announce');
  function annH() { d.documentElement.style.setProperty('--s-announce-h', (ann ? ann.offsetHeight : 0) + 'px'); }
  annH(); on(w, 'resize', annH); on(w, 'load', annH);

  /* ---------- localization (country) select ---------- */
  $$('form[data-s-loc] select').forEach(function (sel) {
    on(sel, 'change', function () { sel.form.submit(); });
  });

  /* ---------- consent banner (Shopify Customer Privacy API) ---------- */
  var banner = $('[data-s-consent]');
  /* If Shopify's own cookie banner is enabled (Settings → Customer privacy), it owns consent:
     keep ours hidden and route the footer "Cookie settings" button to Shopify's preferences panel. */
  function nativeBanner() { return !!(w.privacyBanner && typeof w.privacyBanner.showPreferences === 'function'); }
  if (banner && nativeBanner()) {
    banner.remove(); banner = null;
    $$('[data-s-consent-open]').forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); w.privacyBanner.showPreferences(); }); });
  }
  if (banner) {
    var api = null;
    function show(manage) { if (nativeBanner()) return; banner.classList.add('is-on'); banner.classList.toggle('is-manage', !!manage); }
    function hide() { banner.classList.remove('is-on', 'is-manage'); }
    function set(c) {
      if (!api) { hide(); return; }
      api.setTrackingConsent({ analytics: !!c.analytics, marketing: !!c.marketing, preferences: !!c.preferences, sale_of_data: !!c.marketing }, function () { hide(); });
    }
    function bind() {
      on($('[data-s-consent-accept]', banner), 'click', function () { set({ analytics: true, marketing: true, preferences: true }); });
      on($('[data-s-consent-reject]', banner), 'click', function () { set({ analytics: false, marketing: false, preferences: false }); });
      on($('[data-s-consent-manage]', banner), 'click', function () { show(true); });
      on($('[data-s-consent-save]', banner), 'click', function () {
        set({ analytics: $('[name="s_analytics"]', banner).checked, marketing: $('[name="s_marketing"]', banner).checked, preferences: $('[name="s_preferences"]', banner).checked });
      });
      $$('[data-s-consent-open]').forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); if (nativeBanner()) { w.privacyBanner.showPreferences(); return; } prefill(); show(true); }); });
    }
    function prefill() {
      if (!api) return;
      var c = api.currentVisitorConsent ? api.currentVisitorConsent() : {};
      var a = $('[name="s_analytics"]', banner), m = $('[name="s_marketing"]', banner), p = $('[name="s_preferences"]', banner);
      if (a) a.checked = c.analytics !== 'no'; if (m) m.checked = c.marketing !== 'no'; if (p) p.checked = c.preferences !== 'no';
    }
    bind();
    function boot() {
      if (!(w.Shopify && w.Shopify.loadFeatures)) return;
      w.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (err) return;
        api = w.Shopify.customerPrivacy;
        if (api && api.shouldShowBanner && api.shouldShowBanner()) { prefill(); show(false); }
      });
    }
    if (d.readyState === 'complete') boot(); else on(w, 'load', boot);
  }

  /* ---------- soft-scroll to anchors from other pages is native; mark current nav ---------- */
  $$('.s-nav a, .s-drawer__nav a').forEach(function (a) {
    try { if (new URL(a.href).pathname === w.location.pathname && !a.hash) a.setAttribute('aria-current', 'page'); } catch (e) {}
  });
})();
